import type { LevelKey } from '../types/quiz'
import { levelOrder } from '../data/results'

export function countAnswers(answers: LevelKey[]): Record<LevelKey, number> {
  const tally: Record<LevelKey, number> = { A: 0, B: 0, C: 0, D: 0, E: 0 }
  answers.forEach((answer) => {
    tally[answer] += 1
  })
  return tally
}

export function dominantLevel(answers: LevelKey[]): LevelKey {
  const tally = countAnswers(answers)
  return levelOrder.reduce<LevelKey>(
    (winner, level) => (tally[level] > tally[winner] ? level : winner),
    'A',
  )
}
